export const getWhatsAppFlowDetailsCacheKey =
  "/engagement/:app_group_id/whatsapp/flow_details/:messaging_service_id/:flow_id" as const;
export const getWhatsAppFlowListCacheKey =
  "/engagement/:app_group_id/whatsapp/flows/:messaging_service_id" as const;
export const getWhatsAppFlowListSGCacheKey =
  "/engagement/:app_group_id/whatsapp/flows/sg/:subscription_group_id" as const;
